import React from "react";
import PageRenderer from "../components/PageRender";

const Contatti = () => {
  return <PageRenderer pageIdentifier="news-ed-eventi" />;
};

export default Contatti;
